<template>
	<div class="plugins-pos-container">
		<CardSlashed class="card-info-banner">
			<template #left>
				<div class="card-info-banner-title divider">
					<h2>{{ getString('card_info_title_1_kds') }}</h2>
					<p>{{ getString('card_info_description_1_kds') }}</p>
				</div>
				<div class="card-info-banner-title">
					<h2>{{ getString('dont_you_have_station') }}</h2>
					<p>{{ getString('take_advantage_of_stations') }}</p>
					<p class="br">{{getString('station_kitchen_info')}}</p>
					<div class="card-link-actions" v-if="userStore.currBusiness">
						<AppButton @click="goToSettings"  :text="getString('go_to_settings')" inverted outline/>
					</div>
				</div>
			</template>
			<template #right>
				<div class="wrapper-img">
					<picture>
						<source type="image/webp" srcset="https://img.qromo.io/img/image-info-banner-kds.webp">
						<img src="https://img.qromo.io/img/image-info-banner-kds.png" alt="product image">
					</picture>
				</div>
				<div class="card-link-actions" v-if="userStore.currBusiness">
					<AppButton v-if="this.userStore?.user?.user_id" class="go-to-kitchen-btn" :disabled="!canGoToKitchen" @click="goToKitchen" :text="getString('go_to_kitchen')" />
				</div>
			</template>
		</CardSlashed>
		<PluginsKitchenUsersCard v-if="userStore.currBusiness" />

	</div>
</template>

<script>
import {useLanguageStore, useNotificationStore, useSvgStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";
import {useShopStore} from "@/shop/stores";
import AppPopup from "@/shared/components/AppPopup.vue";
import CardSlashed from "@/console-new/components/shared/CardSlashed.vue";
import AppButton from "@/shared/components/AppButton.vue";
import PluginsKitchenUsersCard from "@/console-new/components/plugins/PluginsKitchenUsersCard.vue";


export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let svgStore = useSvgStore();
		const shopStore = useShopStore();
		const notificationStore = useNotificationStore();
		return {getString: languageStore.getString, showNotification: notificationStore.showNotification, userStore, shopStore, getIcon: svgStore.get}
	},
	name: "PluginsKitchen",
	data() {
		return {
			loadingStatus: false,
			loadingSettings: false,
			loadingUsers: false,
			deletingTerminal: null,
		}
	},
	components: {AppButton, CardSlashed, AppPopup, PluginsKitchenUsersCard},
	computed: {
		canGoToKitchen() {
			if(!this.userStore?.user?.user_id || !this.userStore?.businessUsers) { return false; }
			return this.userStore.businessUsers[this.userStore.user.user_id]?.station;
		}
	},
	methods: {
		goToKitchen() {
			window.location.replace(URL_HTML + "/console/kitchen");
		},
		goToSettings() {
			this.userStore.shouldOpenPermissions = true;
			this.$router.push("/config/settings/general");
		},
		initBusinessUsers() {
			if(this.loadingUsers) { return; }
			if(!this.userStore.user || !this.userStore.user.user_id) {
				return;
			}
			if(!this.userStore.businessUsers || Object.keys(this.userStore.businessUsers).length === 0) {
				this.loadingUsers = true;
				this.userStore.getBusinessUsers(()=>{
					this.loadingUsers = false;
				});
			}
		}
	},
	mounted() {
		this.initBusinessUsers();
	},
	watch: {
		'userStore.user': {
			handler: function (val) {
				if(val) {
					this.initBusinessUsers();
				}
			},
			deep: true
		}
	}
}
</script>

<style lang="scss" scoped>
.plugins-pos-container {

	max-width: 1400px;
	margin: 0 auto;
	.card-margin {
		margin-top: var(--main-padding);
	}
	.card-margin-bottom {
		margin-bottom: var(--main-padding);
	}
	:deep(.card-container .card-body) {
		padding: 0;
		& > .list-container {
			.list-item:first-child::before {
				display: none;
			}
			.list-item:last-child::after {
				display: none;
			}
		}
	}
	.card-info-banner {
		margin-bottom: 40px;
		.card-info-banner-title {
			width: 100%;
			height: fit-content;
			display: flex;
			align-items: flex-start;
			justify-content: flex-start;
			flex-direction: column;
			color: var(--color-txt-white);
			max-width: 400px;
			text-align: left;
			.align-text {
				display:flex;
				flex-direction: column;
			}
			&.divider {
				padding-bottom: 20px;
				border-bottom: 1px solid rgba(255, 255, 255, 0.5);
				width: 100%;
				margin-bottom: 20px;
			}
			h2 {
				font-size: 22px;
				display: inline-block;
				color: var(--color-txt-white);
				@media (max-width: 550px) {
					font-size: 20px;
					line-height: normal;
				}
			}
			p {
				font-size: 16px;
				line-height: 22px;
				color: var(--color-txt-white);
				margin-top: 10px;
				@media (max-width: 550px) {
					font-size: 14px;
					line-height: 20px;
				}
				&.br {
					margin-top: 15px!important;
				}
			}
			.card-info-banner-button {
				margin-top: 20px;
			}
		}
		&:deep(.slashed-card-container) {
			padding: 15px 20px;
			background: linear-gradient(204deg, #D40E2C 10%, rgb(47, 36, 209) 90%);
			height: 100%;
			gap: 40px;
			position: relative;
			.slashed-left {
				width: calc(65% - 20px);
				justify-content: flex-start;
				padding: 0;
				overflow: unset;
				border-radius: 0;
				flex-direction: column;
				z-index: 2;

				.card-info-banner-title {
					width: 100%;
					max-width: unset;
				}
				@media (max-width: 750px) {
					width: calc(55% - 20px);
				}

				@media (max-width: 550px) {
					width: 100%;
					padding: 30px 0 0;
					min-height: unset;
					.card-info-banner-title {
						width: 100%;
						max-width: unset;
					}
				}
			}
			.slashed-right {
				z-index: 2;
				width: calc(35% - 20px);
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 0;
				flex-direction: column;
				@media (max-width: 750px) {
					width: calc(45% - 20px);
				}
				@media (max-width: 550px) {
					width: 100%;
					padding: 0;
				}
			}
			@media (max-width: 550px) {
				flex-direction: column-reverse;
				gap: 0;
			}
		}
		.wrapper-img {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			picture {
				img {
					width: 100%;
					height: 100%;
					max-height: 250px;
					object-fit: contain;
					@media (max-width: 550px) {
						max-height: 200px;
					}
				}
			}
		}
		.icon-link {
			min-height: 40px;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			cursor: pointer;
			gap: 7px;
			margin-top: 8px;
			opacity: .9;
			transition: opacity .2s $transition;
			padding-right: 20px;
			font-size: 14px;
			line-height: 14px;
			font-weight: 400;
			color: var(--color-secondary);
			font-style: italic;
			width: calc(100% - 20px);
			&:after {
				display: none;
			}
			.wrapper-icon {
				margin-top: 2px;
				width: 12px;
				height: 12px;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: transform .2s $transition;
				transform: translateX(0);
				img {
					width: 100%;
					height: 100%;
					max-height: 180px;
					object-fit: contain;
				}
			}
			&:hover {
				opacity: 1;
				.wrapper-icon {
					transform: translateX(2px);
				}
			}
		}
		.card-link-actions {
			display: flex;
			flex-wrap: wrap;
			gap: 20px;
			margin-top: 20px;
		}
	}
}
</style>